import React, {Component, useEffect, useState} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {useCookies} from 'react-cookie';
import GlobalData from "../../../util/GlobalData";
import {useHistory} from "react-router-dom";
import {
    isMobile
} from "react-device-detect";
import EditorPageWrapper from "./EditorPageWrapper";
import Event from "../../../models/Event";
import Class from "../../../models/Class"
import {Button, Card, Col, Container, Row, Tab, Tabs, Tooltip} from "react-bootstrap";
import textFormatter from "../../../util/textFormatter";
import Palette from "../../../util/Palette";
import MobTable from "../../reusable/Table/MobTable";
import moment from "moment";
import CustomButton from "../../reusable/CustomButton";
import {Dialog, DialogContent, DialogTitle, TextField} from "@material-ui/core";
import Topic from "../../../models/Topic";
import {FaSave} from "react-icons/fa";
import ManageTopicModal from "../../reusable/ManageTopicModal";
import CustomDropzone from "../../reusable/CustomDropzone";
import {IoMdEye, IoMdEyeOff} from "react-icons/io";
import {FaMailBulk} from "react-icons/all";
import Badge from "@material-ui/core/Badge";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import LagFreeTextEditor from "../../reusable/LagFreeTextEditor";
import UpcomingEventEditPriceModal from "../../reusable/UpcomingEventEditPriceModal";
import ClassInstructors from "../../../models/ClassInstructors";

export default function EditorMain(props) {
    const [cookie, setCookie, removeCookie] = useCookies(["token"])

    const classModel = new Class();
    const topicModel = new Topic();
    const classInstructorsModel = new ClassInstructors();
    let winWidth = window.innerWidth
    let [events, setEvents] = useState([])
    let [isCreateEventModalOpen, setIsCreateEventModalOpen] = useState(false)

    const [batchUpdateModalVisible, setBatchUpdateModalVisible] = useState(false)

    const [upcomingClass, setUpcomingClass] = useState([])
    const [upcomingClassWithoutDeleted, setUpcomingClassWithoutDeleted] = useState([])

    const [archiveClass, setArchiveClass] = useState([])
    const [archiveClassWithoutDeleted, setArchiveClassWithoutDeleted] = useState([])

    const [isBtnHovered, setBtnHovered] = useState(false);
    const [isModalBtnHovered, setModalBtnHovered] = useState(false);

    let history = useHistory()
    const [isDelete, setDelete] = useState(false)
    const [isHardDelete, setHardDelete] = useState(false)
    const [selectedClass, setSelectedClass] = useState({});
    const [topics, setTopics] = useState([]);
    const [topicsWithoutDeleted, setTopicsWithoutDeleted] = useState([]);
    const [selectedTopic, setSelectedTopic] = useState({});
    const [isManageTopicModalShown, setManageTopicModalShown] = useState(false);
    const [isTopicModalShown, setTopicModalShown] = useState(false);
    const [isDeletingTopic, setDeletingTopic] = useState(false);
    const [isDeletedClassShown, setDeletedClassShown] = useState(true);
    const [isDeletedShown, setDeletedShown] = useState(true);
    let [bannerUrl, setBannerUrl] = useState(null)

    const [isLoading, setIsLoading] = useState(false)

    let [iconLoading, setIconLoading] = useState("");

    const [updateNote, setUpdateNote] = useState("");

    const [isNoteModalVisible, setNoteModalVisible] = useState(false);
    useEffect(() => {
        // getAllEvents()
        getAllClass()
        getAllTopics()
    }, [])

    const getAllTopics = async () => {
        const topicList = await topicModel.getAll();

        const topicsWithoutDeletedTemp = [];

        topicList.forEach(topic => {
            if (topic.active) topicsWithoutDeletedTemp.push(topic)
        })

        setTopicsWithoutDeleted(topicsWithoutDeletedTemp);
        setTopics(topicList);
    }

    const deleteTopic = async () => {
        try {
            const result = await topicModel.delete(selectedTopic.code);

            if (result.success) {
                getAllTopics();
                setDeletingTopic(false);
                alert('Topik berhasil terhapus')
            }
        } catch (e) {
            if (e.msg && typeof e.msg === 'string') {
                alert(e.msg);
            } else {
                alert('Kesalahan terjadi');
            }
        }
    }

    const undeleteTopic = async (code) => {
        try {
            const result = await topicModel.undelete(code);

            if (result.success) getAllTopics()
        } catch (e) {
            if (e.msg && typeof e.msg === 'string') {
                alert(e.msg);
            } else {
                alert('Kesalahan terjadi');
            }
        }
    }

    const getAllClass = async () => {

        setIsLoading(true)

        try {
            let classList = await classModel.getAll();

            if (cookie.userType === 'instructor') {
                const myClass = await classInstructorsModel.getByInstructorId();

                const classListTemp = [];

                myClass.forEach((classObj) => {
                    classList.forEach((classToCheck) => {
                        console.log(classToCheck)
                        if (classObj.class_code === classToCheck.code) {
                            classListTemp.push(classToCheck)
                        }
                    })
                })

                classList = classListTemp;
            }

            const classesWithoutDeletedTemp = [];

            const archiveAll = []
            const archiveNoDeleted = []

            const upcomingAll = []
            const upcomingNoDeleted = []

            classList.forEach(classObj => {
                if (classObj.active) classesWithoutDeletedTemp.push(classObj)
            })

            for (let classObj of classList) {

                classObj.acceptedCount = classObj.metrics?.accepted
                classObj.waitingCount = classObj.metrics?.waiting

                if (classObj.permanent) {
                    if (classObj.active) {
                        upcomingNoDeleted.push(classObj)
                    }
                    upcomingAll.push(classObj)
                }

                if (new Date(classObj.end_time) > new Date()) {
                    if (classObj.active) {
                        upcomingNoDeleted.push(classObj)
                    }
                    upcomingAll.push(classObj)
                } else {
                    if (classObj.active) archiveNoDeleted.push(classObj)
                    archiveAll.push(classObj)
                }

            }

            let upcomingAllReversed = upcomingAll.reverse()
            let upcomingNDReversed = upcomingNoDeleted.reverse()

            setUpcomingClass(upcomingAllReversed)
            setUpcomingClassWithoutDeleted(upcomingNDReversed)

            console.log(archiveAll)

            setArchiveClass(archiveAll)
            setArchiveClassWithoutDeleted(archiveNoDeleted)
            setIsLoading(false)

        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }

    }

    const interactions = [
        {
            name: "Catatan",
            action: (obj) => {
                setUpdateNote(obj.note)
                setSelectedClass(obj)
                setNoteModalVisible(true)
            },
            style: {width: 135},
            condition: (classObj) => {
                return true
                // return classObj.active
            },
        },
        {
            name: "Kelola",
            action: (obj) => {
                if(cookie.userType === 'admin' || cookie.userType === 'superadmin') {
                    history.push("/editor/classDetail/" + obj.code)
                } else {
                    history.push("/editor/visitors/" + obj.code)
                }
            },
            style: {width: 135},
            condition: (classObj) => {
                return true
                // return classObj.active
            },
        },
        {
            name: "Sembunyikan",
            action: (obj) => {
                setSelectedClass(obj)
                setDelete(true)
            },
            variant: 'secondary',
            style: {width: 135},
            condition: (classObj) => {
                return classObj.active && (cookie.userType === 'admin' || cookie.userType === 'superadmin')
            },
        },
        {
            name: "Pulihkan",
            action: (obj) => {
                setSelectedClass(obj)
                undeleteClass(obj)
            },
            variant: 'info',
            style: {width: 135},
            condition: (topic) => {
                return !topic.active && (cookie.userType === 'admin' || cookie.userType === 'superadmin')
            },
        },
        {
            name: "Hapus",
            action: (obj) => {
                setSelectedClass(obj)
                setHardDelete(true)
            },
            variant: 'secondary',
            style: {width: 135},
            condition: (obj) => {
                return cookie.userType === 'admin' || cookie.userType === 'superadmin'
            },
        },
    ];

    const topicInteractions = [
        {
            name: "Sunting",
            action: (obj) => {
                setManageTopicModalShown(true)
                setSelectedTopic(obj);
            },
            style: {width: 100},
            condition: (topic) => {
                return topic.active
            },
            // condition: (topic) => {
            //     console.log(topic)
            //     return !topic.active
            // },
        },
        {
            name: "Hapus",
            action: (obj) => {
                setDeletingTopic(true);
                setSelectedTopic(obj)
            },
            variant: 'secondary',
            style: {width: 100},
            condition: (topic) => {
                return topic.active
            },
        },
        {
            name: "Pulihkan",
            action: (obj) => {
                undeleteTopic(obj.code)
            },
            variant: 'info',
            style: {width: 100},
            condition: (topic) => {
                return !topic.active
            },
        }
    ]

    let columns = [
        {
            Header: "Nama",
            accessor: "name",
            Cell: (cellInfo) => {

                let badgeCount = 0;
                let alerts = ""

                if (new Date(cellInfo.row.original.start_time) < new Date()) {
                    if (!cellInfo.row.original.recording_url_array && cellInfo.row.original.recording_url_array !== "null") {
                        badgeCount++;
                        alerts += "Tautan Rekaman belum tersedia\n"
                    }

                    if (!cellInfo.row.original.show_answers_to_user) {
                        badgeCount++;
                        alerts += "Pertanyaan dan Jawaban belum di tampilkan\n"
                    }

                    if (cellInfo.row.original.certificate_count === 0) {
                        badgeCount++;
                        alerts += "Sertifikat belum dikirim\n"
                    }
                } else {
                    if (!cellInfo.row.original.stream_url) {
                        badgeCount++;
                        alerts += "URL Stream belum diunggah\n"
                    }

                    let obj = cellInfo.row.original

                        if ((!obj.attachment_url && !(obj.attachment_urls && obj.attachment_urls.length > 0))) {
                        badgeCount++;
                        alerts += "Materi kelas belum diunggah\n"
                    }

                    if (!cellInfo.row.original.quiz_question_id) {
                        badgeCount++;
                        alerts += "Tes akhir belum dibuat\n"
                    }
                }


                return <div style={{
                    display: "flex",
                    flexDirection: "row"
                }}>
                    <div>
                        <OverlayTrigger
                            placement="right"
                            overlay={<Tooltip>
                                <div style={{whiteSpace: "pre-line"}}>
                                    {alerts}
                                </div>
                            </Tooltip>}
                        >
                            <Badge
                                style={{display: "inline", position: "relative"}}
                                color="secondary" badgeContent={badgeCount}>
                                <div style={{width: "1em", height: "1em"}}></div>
                            </Badge>
                        </OverlayTrigger>
                    </div>
                    <p>
                        {cellInfo.row.values.name} {cellInfo.row.original.active ? null : <span style={{
                        backgroundColor: Palette.SECONDARY,
                        color: 'white',
                        paddingLeft: 10,
                        paddingRight: 10,
                        borderRadius: 20,
                        marginLeft: 5,
                        fontFamily: 'OpenSans-SemiBold',
                        fontSize: '.9em'
                    }}>Disembunyikan</span>}</p>
                </div>
            }
        },
        {
            Header: "Tanggal & Waktu",
            accessor: "start_time",
            Cell: (cellInfo) => {
                console.log(cellInfo.row.original.class_date)
                console.log(cellInfo.row.original.end_time)

                // let rowInfo = cellInfo.row.values
                //
                // let value = cellInfo.value
                //
                // let startDate = new moment(value)
                //
                // let formattedDate = startDate.format("DD MMMM YYYY, HH:mm")

                // let date = cellInfo.format("DD MMM YYYY")
                if (moment(cellInfo.row.original.class_date).format('DD MMM YYYY') === moment(cellInfo.row.original.end_time).format('DD MMM YYYY')) return <p>{new moment(cellInfo.row.original.class_date).format("D MMMM YYYY, ") + new moment(cellInfo.row.original.start_time).format("HH:mm - ") + new moment(cellInfo.row.original.end_time).format('HH:mm')}</p>

                return <p>{new moment(cellInfo.row.original.class_date).format("D MMMM YYYY, ") + new moment(cellInfo.row.original.start_time).format("HH:mm - ") + new moment(cellInfo.row.original.end_time).format('D MMMM YYYY, HH:mm')}</p>
            }
        },
        {
            Header: "Harga",
            accessor: "price",
            Cell: (cellInfo) => {
                let rowInfo = cellInfo.row.values
                return <p>Rp{textFormatter.moneyFormatter(rowInfo.price)}</p>
                // return null;
            }
        },
        {
            Header: "Daftar",
            accessor: "waitingCount",
            // Cell: (cellInfo) => {
            //     let rowInfo = cellInfo.row.values
            //     return <p>{rowInfo.metrics?.accepted + rowInfo.metrics?.waiting}</p>
            // }
        },
        {
            Header: "Bayar",
            accessor: "acceptedCount",
            // Cell: (cellInfo) => {
            //     let rowInfo = cellInfo.row.values
            //
            //     console.log("byr", rowInfo)
            //
            //     return <p>{rowInfo.metrics?.accepted}</p>
            // }
        },
        {
            Header: "Pemasukan",
            accessor: "metrics",
            Cell: (cellInfo) => {

                let rowInfo = cellInfo.row.values

                let total = rowInfo.price * rowInfo.metrics?.accepted

                return <p>Rp{textFormatter.moneyFormatter(total)}</p>
            }
        },
        {
            Header: "Catatan",
            accessor: "note",
            Cell: (cellInfo) => {

                let rowInfo = cellInfo.row.values

                return <p>{rowInfo.note ? rowInfo.note : '-'}</p>
            }
        }

    ];

    let topicColumn = [
        {
            Header: 'Kode',
            accessor: 'code',
        },
        {
            Header: 'Nama',
            accessor: 'name',
            Cell: (cellInfo) => {
                return <p>{cellInfo.row.original.name} {!cellInfo.row.original.active ? <span style={{
                    backgroundColor: Palette.SECONDARY,
                    color: 'white',
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 20,
                    marginLeft: 5,
                    fontFamily: 'OpenSans-SemiBold',
                    fontSize: '.9em'
                }}>Dihapus</span> : null}</p>;
            }
        }
    ]

    const undeleteClass = async (classObj) => {
        try {
            const result = await classModel.undelete(classObj.code);

            console.log(result)

            if (result.success) {
                getAllClass()

                alert('Kelas ' + classObj.name + ' berhasil dipulihkan!')
            }
        } catch (e) {
            if (e.msg && typeof e.msg === 'string') {
                alert(e.msg);
            } else {
                alert('Kesalahan terjadi');
            }
        }
    }

    const deleteClass = async () => {
        try {
            const result = await classModel.delete(selectedClass.code);

            console.log(result)

            if (result.success) {
                alert('Kelas ' + selectedClass.name + ' berhasil disembunyikan!')

                getAllClass()

                setDelete(false);
            }
        } catch (e) {
            if (e.msg && typeof e.msg === 'string') {
                alert(e.msg);
            } else {
                alert('Kesalahan terjadi');
            }
        }
    }

    const hardDeleteClass = async () => {
        try {
            const result = await classModel.hardDelete(selectedClass.code);

            console.log(result)

            if (result.success) {
                alert('Kelas ' + selectedClass.name + ' berhasil terhapus!')

                getAllClass()

                setHardDelete(false);
            }
        } catch (e) {
            if (e.msg && typeof e.msg === 'string') {
                alert(e.msg);
            } else {
                alert('Kesalahan terjadi');
            }
        }
    }

    const onBannerPicked = async function (image) {
        console.log(image)
        try {
            let result = await new Event().uploadBanner(image, 0)

            console.log(result)

            setBannerUrl(result.location)
        } catch (e) {
            let tempMessage = "Kesalahan Terjadi"
            if (e.msg) {
                if (e.msg.message) {
                    tempMessage = e.msg.message
                }
            }
            setIconLoading(false)

            console.log(e)
        }
    }

    return (
        <>
            <EditorPageWrapper
                isLoadingFull={isLoading}
                activeTab={"home"}
            >
                <Dialog open={isNoteModalVisible}
                        maxWidth="md"
                        fullWidth={true}
                >
                    <DialogTitle onClose={() => {
                        setUpdateNote("");
                        setSelectedClass({})
                        setNoteModalVisible(false)
                    }}>
                        <Row>
                            <Col style={{
                                fontFamily: "OpenSans-Bold",
                                color: Palette.PRIMARY,
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                Catatan {selectedClass.name}
                            </Col>
                        </Row>
                        <hr/>
                    </DialogTitle>
                    <DialogContent>


                        <Row style={{
                            paddingInlineStart: "2%",
                            paddingInlineEnd: "2%",
                            marginTop: '1em'
                        }}
                        >
                            <Col md={12}>
                                <LagFreeTextEditor
                                    title={'Catatan'}
                                    changeValue={value => {
                                        setUpdateNote(value)
                                    }}
                                    value={updateNote}
                                    placeholder={"Catatan"}/>
                            </Col>
                        </Row>

                        <Row style={{
                            paddingInlineStart: "2%",
                            paddingInlineEnd: "2%",
                            paddingTop: '3em',
                            paddingBottom: '1em',
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                        >
                            <CustomButton
                                style={{borderWidth: 0, marginRight: 10, width: 120, fontFamily: 'OpenSans-SemiBold'}}
                                onClick={() => {
                                    setUpdateNote("");
                                    setSelectedClass({})
                                    setNoteModalVisible(false)
                                }}
                                variant={"outlined"} color="primary">
                                Batal
                            </CustomButton>

                            <CustomButton
                                onClick={async () => {
                                    try {
                                        const classModel = new Class();

                                        const result = await classModel.updateNote(selectedClass.code, updateNote);

                                        if (result.success) {
                                            setSelectedClass({})
                                            setUpdateNote("")
                                            setNoteModalVisible(false);

                                            alert('Catatan berhasil diperbarui!');

                                            getAllClass();
                                        }
                                    } catch (e) {
                                        console.log(e)
                                    }
                                }}
                                style={{color: 'white', width: 120, fontFamily: 'OpenSans-SemiBold'}}
                                variant={"contained"} color="primary">
                                <>Simpan&nbsp;&nbsp;<FaSave/></>
                            </CustomButton>
                        </Row>
                    </DialogContent>
                </Dialog>

                <Dialog open={isTopicModalShown}
                        maxWidth="md"
                        fullWidth={true}
                        onClose={() => setTopicModalShown(false)}
                >
                    <DialogTitle>
                        <Row>
                            <Col style={{
                                fontFamily: "OpenSans-Bold",
                                color: Palette.PRIMARY,
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                Kelola Topik

                                <Row style={{marginLeft: 2, marginTop: 15}}>
                                    <Button variant={'info'}
                                            onClick={() => setDeletedShown(!isDeletedShown)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: 30,
                                                fontSize: '.65em',
                                                fontFamily: 'OpenSans-SemiBold',
                                                // marginTop: 4,
                                                width: 200,
                                                color: 'white', marginRight: 5
                                            }}
                                    >
                                        {isDeletedShown ? <IoMdEyeOff style={{marginRight: 10}}/> :
                                            <IoMdEye style={{marginRight: 10}}/>}
                                        {isDeletedShown ? 'Sembunyikan Tersembunyi' : 'Tampilkan Tersembunyi'}
                                    </Button>

                                    <Button variant={'outline-primary'}
                                            onMouseEnter={() => setModalBtnHovered(true)}
                                            onMouseLeave={() => setModalBtnHovered(false)}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: 30,
                                                fontSize: '.65em',
                                                fontFamily: 'OpenSans-SemiBold',
                                                color: isModalBtnHovered ? 'white' : Palette.PRIMARY,
                                                width: 150,
                                                marginRight: 5
                                            }}
                                            onClick={() => setManageTopicModalShown(true)}
                                    >
                                        + <span style={{marginLeft: 6}}>Tambah Baru</span>
                                    </Button>

                                    {/*<Button variant={'info'}*/}
                                    {/*        style={{*/}
                                    {/*            display: 'flex',*/}
                                    {/*            alignItems: 'center',*/}
                                    {/*            justifyContent: 'center',*/}
                                    {/*            height: 30,*/}
                                    {/*            fontSize: '.8em',*/}
                                    {/*            fontFamily: 'OpenSans-SemiBold',*/}
                                    {/*            // marginTop: 4,*/}
                                    {/*            width: 200,*/}
                                    {/*            color: 'white', marginRight: 5*/}
                                    {/*        }}*/}
                                    {/*>*/}
                                    {/*    <IoMdEye style={{marginRight: 10}}/>*/}
                                    {/*    Tampilkan Terhapus*/}
                                    {/*</Button>*/}
                                    {/*<Button variant={'outline-primary'}*/}
                                    {/*        onMouseEnter={() => setModalBtnHovered(true)}*/}
                                    {/*        onMouseLeave={() => setModalBtnHovered(false)}*/}
                                    {/*        style={{*/}
                                    {/*            display: 'flex',*/}
                                    {/*            alignItems: 'center',*/}
                                    {/*            justifyContent: 'center',*/}
                                    {/*            height: 30,*/}
                                    {/*            fontSize: '.65em',*/}
                                    {/*            fontFamily: 'OpenSans-SemiBold',*/}
                                    {/*            color: isModalBtnHovered ? 'white' : Palette.PRIMARY,*/}
                                    {/*            width: 140,*/}
                                    {/*            marginLeft: 2,*/}
                                    {/*            marginTop: 15*/}
                                    {/*        }}*/}
                                    {/*        onClick={() => setManageTopicModalShown(true)}*/}
                                    {/*>*/}
                                    {/*    + <span style={{marginLeft: 6}}>Tambah Baru</span>*/}
                                    {/*</Button>*/}
                                </Row>
                            </Col>
                        </Row>
                        <hr/>
                    </DialogTitle>

                    <DialogContent>
                        <MobTable
                            columns={topicColumn}
                            data={isDeletedShown ? topics : topicsWithoutDeleted}
                            interactions={topicInteractions}
                        />
                    </DialogContent>
                </Dialog>


                <Dialog open={isDeletingTopic}
                        maxWidth="sm">
                    <>
                        <DialogTitle onClose={() => this.onClose()}>
                            <Row>
                                <Col style={{
                                    fontFamily: "OpenSans-Bold",
                                    color: Palette.PRIMARY,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    Konfirmasi Hapus Topik
                                </Col>
                            </Row>
                            <hr/>
                        </DialogTitle>

                        <DialogContent style={{fontFamily: 'OpenSans-Regular', fontSize: '1.1em'}}>
                            Apakah anda yakin ingin menghapus topik <span
                            style={{fontFamily: 'OpenSans-Bold'}}>{selectedTopic.name}</span>?


                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: 30,
                                marginRight: 15,
                                marginBottom: 15
                            }}>
                                <CustomButton
                                    onClick={() => {
                                        setDeletingTopic(false)
                                    }}
                                    style={{borderWidth: 0, width: 120, fontFamily: 'OpenSans-SemiBold'}}
                                    variant={"outlined"}
                                    color="primary">
                                    Batal
                                </CustomButton>

                                <CustomButton
                                    style={{marginLeft: 10, width: 120, fontFamily: 'OpenSans-SemiBold'}}
                                    onClick={deleteTopic}
                                    variant={"contained"}
                                    color="secondary">
                                    Hapus
                                </CustomButton>
                            </div>
                        </DialogContent>
                    </>
                </Dialog>

                <ManageTopicModal visible={isManageTopicModalShown} hide={() => {
                    setSelectedTopic({})
                    setManageTopicModalShown(false)
                }} selectedTopic={selectedTopic} updateData={getAllTopics}/>

                <Dialog open={isDelete}
                        maxWidth="sm"
                        fullWidth={true}
                >
                    <>
                        <DialogTitle onClose={() => this.onClose()}>
                            <Row>
                                <Col style={{
                                    fontFamily: "OpenSans-Bold",
                                    color: Palette.PRIMARY,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    Konfirmasi Sembunyikan Kelas
                                </Col>
                            </Row>
                            <hr/>
                        </DialogTitle>

                        <DialogContent style={{fontFamily: 'OpenSans-Regular', fontSize: '1.1em'}}>
                            Apakah anda yakin ingin menyembunyikan kelas <span
                            style={{fontFamily: 'OpenSans-Bold'}}>{selectedClass.name}</span>?


                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: 30,
                                marginRight: 15,
                                marginBottom: 15
                            }}>
                                <CustomButton
                                    onClick={() => {
                                        setDelete(false)
                                    }}
                                    style={{fontFamily: 'OpenSans-SemiBold', width: 120}}
                                    variant={"outlined"}
                                    color="primary">
                                    Batal
                                </CustomButton>

                                <CustomButton
                                    style={{marginLeft: 10, fontFamily: 'OpenSans-SemiBold', width: 120}}
                                    onClick={deleteClass}
                                    variant={"contained"}
                                    color="secondary">
                                    Sembunyikan
                                </CustomButton>
                            </div>
                        </DialogContent>
                    </>
                </Dialog>

                <Dialog open={isHardDelete}
                        maxWidth="sm"
                        fullWidth={true}
                >
                    <>
                        <DialogTitle onClose={() => {
                            setHardDelete(false)
                            setSelectedClass({})
                        }}>
                            <Row>
                                <Col style={{
                                    fontFamily: "OpenSans-Bold",
                                    color: Palette.PRIMARY,
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                    Konfirmasi Hapus Kelas
                                </Col>
                            </Row>
                            <hr/>
                        </DialogTitle>

                        <DialogContent style={{fontFamily: 'OpenSans-Regular', fontSize: '1.1em'}}>
                            Apakah anda yakin ingin menghapus kelas <span
                            style={{fontFamily: 'OpenSans-Bold'}}>{selectedClass.name}</span>?


                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: 30,
                                marginRight: 15,
                                marginBottom: 15
                            }}>
                                <CustomButton
                                    onClick={() => {
                                        setHardDelete(false)
                                        setSelectedClass({})
                                    }}
                                    style={{fontFamily: 'OpenSans-SemiBold', width: 120}}
                                    variant={"outlined"}
                                    color="primary">
                                    Batal
                                </CustomButton>

                                <CustomButton
                                    style={{marginLeft: 10, fontFamily: 'OpenSans-SemiBold', width: 120}}
                                    onClick={hardDeleteClass}
                                    variant={"contained"}
                                    color="secondary">
                                    Hapus
                                </CustomButton>
                            </div>
                        </DialogContent>
                    </>
                </Dialog>

                <>

                    <div style={{display: 'flex', flexDirection: 'column', marginBottom: 30, marginTop: '1.75em'}}>
                        <div style={{
                            color: Palette.PRIMARY,
                            fontSize: "1.75em",
                            fontFamily: "OpenSans-Bold",
                            marginRight: 25
                        }}>
                            Daftar Kelas
                        </div>

                        <Row style={{marginLeft: 2, marginTop: 15}}>
                            <Button variant={'info'}
                                    onClick={() => setDeletedClassShown(!isDeletedClassShown)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 30,
                                        fontSize: '.8em',
                                        fontFamily: 'OpenSans-SemiBold',
                                        // marginTop: 4,
                                        width: 200,
                                        color: 'white', marginRight: 5
                                    }}
                            >
                                {isDeletedClassShown ? <IoMdEyeOff style={{marginRight: 10}}/> :
                                    <IoMdEye style={{marginRight: 10}}/>}
                                {isDeletedClassShown ? 'Sembunyikan Terhapus' : 'Tampilkan Terhapus'}
                            </Button>

                            <Button variant={'primary'}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 30,
                                        fontSize: '.8em',
                                        fontFamily: 'OpenSans-SemiBold',
                                        // marginTop: 4,
                                        width: 140,
                                        color: 'white'
                                    }}
                                    onClick={() => setTopicModalShown(true)}
                            >
                                Kelola Topik
                            </Button>

                            {cookie.userType === 'admin' &&
                            <Button variant={'outline-primary'}
                                    onMouseEnter={() => setBtnHovered(true)}
                                    onMouseLeave={() => setBtnHovered(false)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 30,
                                        fontSize: '.8em',
                                        fontFamily: 'OpenSans-SemiBold',
                                        color: isBtnHovered ? 'white' : Palette.PRIMARY,
                                        width: 140,
                                        marginLeft: 5,
                                        marginRight: 5
                                    }}
                                    onClick={() => history.push("/create-class")}
                            >
                                + <span style={{marginLeft: 6}}>Buat Kelas Baru</span>
                            </Button>
                            }
                        </Row>

                        <Row style={{marginLeft: 2, marginTop: 5}}>
                            <Button
                                onClick={() => {
                                    setBatchUpdateModalVisible(true)
                                }}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: 30,
                                    fontSize: '.8em',
                                    fontFamily: 'OpenSans-SemiBold',
                                    width: 300,
                                    color: "white"
                                }}
                            >
                                Ubah Harga Kelas Mendatang
                            </Button>
                        </Row>

                        {/*<CustomButton*/}
                        {/*    onClick={() => setAdminManagementModalVisible(true)}*/}
                        {/*    style={{marginTop: 20, borderWidth: 0, fontFamily: 'OpenSans-SemiBold'}}*/}
                        {/*    variant={"outlined"}>+ Tambah Admin</CustomButton>*/}
                    </div>

                    {/*<div style={{display: 'flex', alignItems: 'center', marginBottom: 30}}>*/}
                    {/*    <div style={{*/}
                    {/*        marginTop: "1em",*/}
                    {/*        marginBottom: "0.5em",*/}
                    {/*        fontFamily: "OpenSans-Bold",*/}
                    {/*        flex: 1*/}
                    {/*    }}>Daftar Kelas</div>*/}

                    {/*    <CustomButton*/}
                    {/*        onClick={() => history.push("/create-event")}*/}
                    {/*        style={{marginTop: 20, borderWidth: 0, fontFamily: 'OpenSans-SemiBold', fontWeight: '500'}}*/}
                    {/*        variant={"outlined"}>+ Buat Kelas Baru</CustomButton>*/}
                    {/*</div>*/}

                    {/*<b style={{*/}
                    {/*    marginTop: "1em",*/}
                    {/*    marginBottom: "0.5em",*/}
                    {/*    fontFamily: "Montserrat"*/}
                    {/*}}>Daftar Kelas</b>*/}

                    <br/>


                    <Tabs defaultActiveKey="upcoming">
                        <Tab
                            eventKey="upcoming"
                            title={
                                "Akan Datang"
                            }
                        >
                            <div style={{
                                marginTop: 10
                            }}>
                                <MobTable
                                    columns={columns}
                                    data={isDeletedClassShown ? upcomingClass : upcomingClassWithoutDeleted}
                                    interactions={interactions}
                                />
                            </div>
                        </Tab>
                        <Tab
                            eventKey="archive"
                            title={"Arsip"}
                        >
                            <div style={{
                                marginTop: 10
                            }}>
                                <MobTable
                                    columns={columns}
                                    data={isDeletedClassShown ? archiveClass : archiveClassWithoutDeleted}
                                    interactions={interactions}
                                />
                            </div>
                        </Tab>
                    </Tabs>

                </>
            </EditorPageWrapper>
            <UpcomingEventEditPriceModal
                classes={upcomingClass}
                isOpen={batchUpdateModalVisible}
                onClose={(refresh) => {
                    setBatchUpdateModalVisible(false)
                    if (refresh) {
                        getAllClass()
                    }
                }}
            />
        </>

    );

}
